import { Modal } from "../../common/components/Modal";
import { useRef } from "react";
import { WhatsappShareButton, WhatsappIcon } from "react-share";
import { ItemConst } from "../../../constants/ItemConst";
import { useIntl } from "react-intl";

export const ReceiptDialog = ({ inputValues }) => {
  const dismissBtnRef = useRef();
  const intl = useIntl();
  // Generate the share message
  const message = ItemConst.map((item, index) => {
    if (inputValues[index] > 0) {
      const codeOrTitle = item.code || intl.formatMessage({ id: item.title });
      return `${codeOrTitle}: ${inputValues[index]} x RM ${item.price} = RM ${(
        inputValues[index] * parseFloat(item.price)
      ).toFixed(2)}`;
    }
    return null;
  })
    .filter(Boolean)
    .join("\n");

  const total = ItemConst.reduce((sum, item, index) => {
    if (inputValues[index] > 0) {
      return sum + inputValues[index] * parseFloat(item.price);
    }
    return sum;
  }, 0);
  const orderDate = new Date().toLocaleDateString();
  const shareUrl = `${message}\n\n ${intl.formatMessage({
    id: "price",
  })}: RM ${total.toFixed(2)} \n ( ${intl.formatMessage({
    id: "orderDate",
  })}: ${orderDate})`;
  return (
    <Modal
      modalId="receiptModal"
      title={intl.formatMessage({
        id: "confirmation",
      })}
      dismissBtnRef={dismissBtnRef}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: "8px" }}>
              {intl.formatMessage({
                id: "item",
              })}
            </th>
            <th style={{ textAlign: "right", padding: "8px" }}>
              {intl.formatMessage({
                id: "quantity",
              })}
            </th>
            <th style={{ textAlign: "right", padding: "8px" }}>
              {intl.formatMessage({
                id: "price",
              })}
            </th>
          </tr>
        </thead>
        <tbody>
          {ItemConst.map(
            (item, index) =>
              inputValues[index] > 0 && (
                <tr key={index}>
                  <td style={{ padding: "8px" }}>
                    {item.code
                      ? `${intl.formatMessage({
                          id: item.title,
                        })} (${item.code})`
                      : intl.formatMessage({ id: item.title })}
                  </td>
                  <td style={{ textAlign: "right", padding: "8px" }}>
                    {inputValues[index]}
                  </td>
                  <td style={{ textAlign: "right", padding: "8px" }}>
                    {"RM" +
                      (inputValues[index] * parseFloat(item.price)).toFixed(2)}
                  </td>
                </tr>
              )
          )}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan="2"
              style={{
                textAlign: "right",
                padding: "8px",
                fontWeight: "bold",
              }}
            >
              {intl.formatMessage({ id: "total" })}:
            </td>
            <td
              style={{
                textAlign: "right",
                padding: "8px",
                fontWeight: "bold",
              }}
            >
              {"RM" + total.toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
      <div
        style={{
          textAlign: "center",
        }}
      >
        <hr style={{ width: "100%" }} />
        <div>{intl.formatMessage({ id: "shareOrder" })} :</div>
      </div>

      <div
        className="my-2"
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <WhatsappShareButton url={shareUrl} disabled={total === 0}>
          <WhatsappIcon size={35} round />
        </WhatsappShareButton>
      </div>
    </Modal>
  );
};
